import styled from 'styled-components';

import { Color } from '../../../../../../../constants/Colors';
import { MediaQuery } from '../../../../../../../constants/Styles';
import { Typography } from '../../../../../../../constants/Typographies';

export const StyledInput = styled.input`
  ${Typography.M};
  color: ${Color.CLOUD_BURST};
  box-sizing: border-box;
  min-height: 45px;
  width: 520px;
  display: flex;
  flex-grow: 1;
  padding: 0px 12px 0px 52px;
  margin: 0;
  border-radius: 22.5px;
  background-color: transparent;
  letter-spacing: 0;
  line-height: 22px;
  outline: none;
  border: 2px solid ${Color.MYSTIC};

  &::placeholder {
    color: ${Color.DOLPHIN};
  }

  // This is hidding an icon from the Algolia SearchBox input
  &[type='search']::-webkit-search-cancel-button {
    display: none;
  }

  &:focus-visible {
    border: 2px solid ${Color.CLOUD_BURST};
  }

  ${MediaQuery.L_AND_DOWN} {
    width: 360px;
  }

  ${MediaQuery.S_AND_DOWN} {
    width: 100%;
  }
`;
